import React, { useState, useEffect, useRef } from 'react';
import toWav from 'audiobuffer-to-wav';
import { Buffer } from 'buffer';
import axios from 'axios';
import { useUserAuth } from "../context/UserAuthContext";
import { set } from 'react-hook-form';
import { FFmpeg } from '@ffmpeg/ffmpeg';       // v0.12+ 核心包
import { fetchFile } from '@ffmpeg/util';      // fetchFile 已移到 util 包

const CHUNK_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_RETRY = 5;
// const ffmpeg = createFFmpeg({ log: true });
const ffmpeg = new FFmpeg({                   
  log: true,
  // 如有需要，可以指定 corePath 指向你的 ffmpeg-core.js
  // corePath: '/ffmpeg_core_dist/ffmpeg-core.js'
});

// Global variable to track the current active transcription task ID
let currentTranscriptionTaskID = null;
let flagOFupdatedSuccessfullySetByUser = false;

const SpeechToTextOffline = ({ isVisible, onClose, onReceiveData, goHistory, setAudioName, popupStatus, popupMinORMax, videoURLFromHome, batchCreateHistory, startGPTBatch, upgradeUserLevel}) => {
  // endTimeOfLocalSave, saveAudioLocally
  //2025.04.21 OpenAI Batch 
  /* ------------------ ★ 新增：多链接队列 ------------------ */
  const [linkQueue, setLinkQueue] = useState([]);         // 等待处理的链接
  const queueBusyRef = useRef(false);                     // 是否正在处理
  const expectedTotalRef = useRef(0);                     // 需要 transcript 的总数
  const transcriptsForBatch = useRef([]);                 // {id, transcript}
  const cancelledBatchTasksRef = useRef([]);                 // 已取消的任务 {url, error}
  /* ------------------ ★ 新增：多链接队列 ------------------ */
  
  const [audioFileUserUpload, setAudioFileUserUpload] = useState(null); //the file selected or dropped by user, not the name of file, just the file itself
  const [audioFileUserUploadArray, setAudioFileUserUploadArray] = useState([]); //the files array selected or dropped by user, not the name of file, just the file itself
  const [fileName, setFileName] = useState('');   //the name of selected or dropped file, just the name need to be displayed to user
  const [uploadedFileName, setUploadedFileName] = useState('');  //the name of uploaded file(audio blob) to server, delete file from server(from uploads folder) need it 
  // const [url, setUrl] = useState(null);  //the url of uploaded file(audio blob) to server, batch transcribe need it
  const [transcription, setTranscription] = useState({
    text: '',
    transcribeID: '',
    url: '',
    PolishedText: '',
    videoURL: '',
    videoID: '',
    duration: 0,
    title: '',
    noteIDnum: '',
    subtitleWithTimestamp: ''
  });
  const [error, setError] = useState(null);

  //_______________________________________________________________________________________
  const [isPreCheckingAudioFile, setIsPreCheckingAudioFile] = useState(false);
  const [isTranscribing, setIsTranscribing] = useState(false);
  const [isVisibleSTT, setIsVisibleSTT] = React.useState(false);
  const [isUpdatingHistory, setIsUpdatingHistory] = useState(false);

  const [duration, setDuration] = useState(0);
  const [progressOfPrecheck, setProgressOfPrecheck] = useState(0);
  const [progressOfUpload, setProgressOfUpload] = useState(0);
  const [progressOfTranscription, setProgressOfTranscription] = useState(0);
  const sdk = require("microsoft-cognitiveservices-speech-sdk");
  const [uploading, setUploading] = useState(false);
  const [progressStatus, setProgressStatus] = useState('');
  const { updatedSuccessfully, setUpdatedSuccessfully, user, userDataLocal, setIsOfflineTranscribing, 
    setTaskIDOfOfflinetranscribe, updateVideoData, getVideoData, setCurrentUpdateReason, checkToken, 
   userVipLevel } = useUserAuth();
  const [sumOFSelectedFiles, setSumOFSelectedFiles] = useState(0);
  const [sumOFUploadedFiles, setSumOFUploadedFiles] = useState(1);
  const [endTimeOfAudio, setEndTimeOfAudio] = useState(null); //2024.09.06 add for record the end time of audio file

  const [completedAllOfFiles, setCompletedAllOfFiles] = useState(true);

  const [videoURLAddress, setVideoURLAddress] = useState({
    videoURL: '',
    videoID: '',
    audioURL: '',
    title: '',
    duration: 0,
    noteIDnum: '',
    lancode: ''
  });
  const [videoURLAddressTemp, setVideoURLAddressTemp] = useState(videoURLFromHome ||'');
  const [noteExist, setNoteExist] = useState(null);
  const [userCancleTranscribe, setUserCancleTranscribe] = useState(false);
  const userCancleTranscribeRef = useRef(userCancleTranscribe);
  const [batchTaskLength, setBatchTaskLength] = useState(0);

  const allowedFormats = [
    'audio/wav',
    'audio/x-wav',
    'audio/mp3',
    'audio/mpeg',
    'audio/ogg',
    'audio/flac',
    'audio/x-ms-wma',
    'audio/wma',
    'audio/aac',
    'audio/x-aac',
    'audio/x-alaw-basic',
    'audio/x-mulaw-basic',
    'audio/amr',
    'audio/webm',
    'audio/mp4',
    'audio/x-m4a',
    'audio/mp4',
    'audio/speex',
    'video/webm'
  ];

  const [messageShowToUser, setMessageShowToUser] = useState('Drag and drop an audio file here. Supported audio formats: mp3, wav, ogg, flac, wma, aac, amr, webm, mp4, m4a, speex.');

  const currentUsageTimeTotalRef = useRef(userDataLocal?.Usage?.time || 0); 

  useEffect(() => {
    const dropzone = document.querySelector('.dropzone-STT');
  
    function handleDragEnter() {
      this.classList.add('dragging');
    }
  
    function handleDragLeave(e) {
      if (!dropzone.contains(e.relatedTarget)) {
        this.classList.remove('dragging');
      }
      e.preventDefault();
    }

    function handleDragOver(event) {
      event.preventDefault();
    }

    function handleDrop(event) {
      event.preventDefault();
      this.classList.remove('dragging');
      // 在这里处理文件
    }
  
    dropzone.addEventListener('dragenter', handleDragEnter);
    dropzone.addEventListener('dragleave', handleDragLeave);
    dropzone.addEventListener('dragover', handleDragOver);
    dropzone.addEventListener('drop', handleDrop);

    currentUsageTimeTotalRef.current = userDataLocal?.Usage?.time || 0;
  
    return () => {
      dropzone.removeEventListener('dragenter', handleDragEnter);
      dropzone.removeEventListener('dragleave', handleDragLeave);
      dropzone.removeEventListener('dragover', handleDragOver);
      dropzone.removeEventListener('drop', handleDrop);
    };
  }, []);
  
  //begin upload the file user selected/droped to server and get the url of the file
  //Now not't handle upload a new file when the previous file is still uploading
  //_______________________________________________________________________________________
  //Running logic:
  //setAudioFileUserUploadArray => preCheckAudioFile(audioFile)  => setAudioFileUserUpload => 
  //handleUpload() => setUrl => startBatchTranscribe() => setIsTranscribing => 
  //setAudioFileUserUploadArray(remove the first element)
  //_______________________________________________________________________________________

  useEffect(() => {
    if((audioFileUserUploadArray.length > 0) && !isTranscribing){
      const audioFile = audioFileUserUploadArray[0];
      preCheckAudioFile(audioFile);
      // console.log('audioFileUserUploadArray:', audioFileUserUploadArray);
      if(!error) {
        setMessageShowToUser(`Processing the ${sumOFUploadedFiles}/${sumOFSelectedFiles}th file, please wait`);
      } else {
        setMessageShowToUser('Network Error! Please try again later.');
      }
    } else if (audioFileUserUploadArray.length === 0 && !isTranscribing) {
      if(transcription.text !== '' && !error) {
        console.log('All the file uploaded done! audioFileUserUploadArray is empty!');
        // setMessageShowToUser('All of the files have been done. Drag and drop audio files here agin.');
      }
      setAudioFileUserUpload(null);
      setProgressOfUpload(0);
      setUploadedFileName('');
      // setError(null);
      setUploading(false);
      setIsTranscribing(false);
    } else {
      // console.log('audioFileUserUploadArray:', audioFileUserUploadArray);
    }
    setIsOfflineTranscribing(isTranscribing);
  }, [audioFileUserUploadArray, isTranscribing]);

  useEffect(() => {
    if(!isTranscribing && audioFileUserUploadArray.length <= 0 && transcription.text !== '') {
      // && progressOfTranscription === 100 
      if (updatedSuccessfully) {
        setIsUpdatingHistory(false);
        setProgressStatus('Done');
        setError(null);
        // if( !messageShowToUser.includes('History updated successfully!') ) {
          setMessageShowToUser('History updated successfully! You can view it by clicking the Transcript button below. All of the files have been done. Drag and drop audio files here agin.  ');
        //  }
        //  setProgressOfTranscription(0);
        // setUpdatedSuccessfully(false);
        flagOFupdatedSuccessfullySetByUser = false;
      } else if(!flagOFupdatedSuccessfullySetByUser) {
        // setMessageShowToUser('An error occurred while updating history records. Please refresh the page.');
        setError('An error occurred while updating history records. Please refresh the page.');
        setProgressStatus('Failed');
        setTimeout(() => {
          setIsUpdatingHistory(false);
        }, 2000);
      }
    } 
    // else {
    //   if (updatedSuccessfully) {
    //     setIsUpdatingHistory(false);
    //     if( !messageShowToUser.includes('History updated successfully!') ) {
    //       setMessageShowToUser('History updated successfully! You can view it by clicking the Transcript button below. ');
    //      }
    //   }
    // }
  }, [updatedSuccessfully, audioFileUserUploadArray]);
  //, isTranscribing, progressOfTranscription

  useEffect(() => {
    if(audioFileUserUpload && !isTranscribing) {
      handleUpload();
      expectedTotalRef.current = -2; //音频上传完成后，设置为-2，表示不需要批量处理，也不是视频处理
      // console.log('audioFileUserUpload:', audioFileUserUpload);
    } 
  }, [audioFileUserUpload]);

  useEffect(() => {
    if (userCancleTranscribeRef.current && expectedTotalRef.current === -1) {
      // console.log('HandleUpload quit.');
      setProgressStatus('Cancelled');
    } else {
      if(videoURLAddress.audioURL !== '' && !videoURLAddress.audioURL?.includes('localhost')) {
        setEndTimeOfAudio(Date.now());
        if (uploading) setUploading(false);
        const videoURL = videoURLAddress.videoURL;
        const audioURL = videoURLAddress.audioURL;
        const videoID = videoURLAddress.videoID;
        const duration = videoURLAddress.duration;
        const title = videoURLAddress.title;
        const noteIDnum = videoURLAddress.noteIDnum;
        const lancode = videoURLAddress.lancode || userDataLocal?.Language?.code || 'en-US';
        startBatchTranscribe(audioURL, videoURL, videoID, duration, title, noteIDnum, lancode);
      } else{
        setEndTimeOfAudio(null);
        if (videoURLAddress.audioURL?.includes('localhost')) {
          console.log('The audio file is saved locally, so it can not be transcribed by batch transcribe.');
          setMessageShowToUser('The audio file is saved locally, so it can not be transcribed by batch transcribe. Please try again later.');
          setUploading(false);
          setProgressStatus('Cancelled');
        }
      }
    }
  }, [videoURLAddress]);

  useEffect(() => {
    if (isTranscribing && audioFileUserUploadArray.length > 0) {
      setAudioFileUserUploadArray(prevArray => prevArray.slice(1));
    }
  }, [isTranscribing]);


  useEffect(() => {
    // console.log('popupStatus:', popupStatus);
    setIsVisibleSTT(isVisible);
  }, [isVisible, popupStatus]);


  //2024.05.31 update usage and transcription to parent component
  useEffect(() => {
    let delaySet = null;
    let audiofilenameofCloud = uploadedFileName;
    if(transcription.text !== '' && transcription.duration > 0) {
      let usageSum = Math.round(transcription.duration / 60 * 100) / 100;
      if(usageSum < 1) usageSum = 1;
      let inputValue = transcription.text;
      let endTime = endTimeOfAudio;
      if(!endTime) endTime = Date.now();
      const realtimeBoolValue = false;
      let transcribeID = transcription.transcribeID;
      let url = transcription.url;
      let noteIDnum = transcription.noteIDnum;
      let polishedText = transcription.PolishedText;
      let videoURL = transcription.videoURL; 
      let videoID = transcription.videoID;
      let title = transcription.title;
      let subtitleWithTimestamp = transcription.subtitleWithTimestamp;
      setAudioName(audiofilenameofCloud);
      console.log('Start create history');
      setCurrentUpdateReason('sttTranscribe');
      flagOFupdatedSuccessfullySetByUser = true;
      setUpdatedSuccessfully(false);
      onReceiveData(inputValue, usageSum, endTime, realtimeBoolValue, transcribeID, url, noteIDnum, videoURL, videoID, polishedText, title, subtitleWithTimestamp);
    } else if (transcription.text === '') {
      setUpdatedSuccessfully(false);
    }
    return () => {
      if(delaySet) clearTimeout(delaySet);
    }
  }, [transcription]);

  //2024.10.25
  useEffect(() => {
    // console.log('progressStatus:', progressStatus); 
    if(progressStatus == 'Done' || progressStatus == '' || progressStatus == 'Failed') {
      setCompletedAllOfFiles(true);
    } else {
      setCompletedAllOfFiles(false);
    }
  }, [progressStatus]);

  //2024.10.28
  useEffect(() => {
    // console.log('completedAllOfFiles:', completedAllOfFiles, 'current time is:', Date.now());
    if(!completedAllOfFiles && !isVisibleSTT && isVisible) {
      popupMinORMax('min');
    } else {
      popupMinORMax('max');
    }
  }, [isVisibleSTT]);

  useEffect(() => {
    userCancleTranscribeRef.current = userCancleTranscribe;
  }, [userCancleTranscribe]);

  useEffect(() => {
    if (videoURLFromHome) {
      handleUrlArrayPreProcess();
    }
  }, [videoURLFromHome]);

  // —————————————————————————————————————————————————
  //2025.04.21 OpenAI Batch
  /* ------------------------------------------------------ */
  const decideHowToProcess = async (url) => {
    const videoId = extractVideoId(url);
    if (!videoId) return { mode: "invalid" };

    let errorMessage = '';
    const noteInUserDataLocal = userDataLocal.History.find(item => item.videoID === videoId);
    if (noteInUserDataLocal) {
      errorMessage = 'This video has been transcribed before. Please check your history. It maybe created at ' + noteInUserDataLocal.date + '. You can view it by clicking the Transcript button below.';
      return { mode: "skip_done", error: errorMessage };
    }

    // b) 本地完整历史
    // const localRec = userDataLocal?.History?.find(r => r.videoID === videoId && r.transcript && r.transcript !== 'Transcript updating...');
    // if (localRec) {
    //   return { mode: "skip_done" };
    // }

    // // c) 已启动未完成
    // const partial = userDataLocal?.History?.find(r => r.videoID === videoId && (!r.transcript || r.transcript === 'Transcript updating...')  && r.transcribeID);
    // if (partial) {
    //   return { mode: "resume" };
    // }

    // // d) YTBList 全局缓存
    // const videoData = await getVideoData(videoId, url);
    // const { Duration, Language, PolishedText, Title, Transcript, AudioUrl, TranscribeID, AudioUploaded, subtitleWithTimestamp } = videoData;
    // updateTranscription(Transcript, TranscribeID, AudioUrl, PolishedText, videoUrl, videoId, Duration, Title, noteIDnum, subtitleWithTimestamp);
    // if (videoData && videoData?.subtitleWithTimestamp) {
    //   // return { mode: "skip_cached", transcript: videoData?.subtitleWithTimestamp };
    //   return { mode: "skip_cached", transcript: videoData?.Transcript, videoId, url, subtitleWithTimestamp: videoData?.subtitleWithTimestamp };
    // }

    // // e) YouTube 自动字幕
    // const autoCap = await getVideoTitle(url); 
    // if (autoCap && autoCap?.subtitleWithTimestamp) {
    //   return { mode: "skip_cached", transcript: autoCap?.Transcript, videoId, url, subtitleWithTimestamp: autoCap?.subtitleWithTimestamp };
    // }

    // f) 需要下载 + 转写
    return { mode: "transcribe", url, videoId };
  };
  /* ------------------------------------------------------ */

  // useEffect(() => {
  //   console.log('linkQueue.length:', linkQueue.length, 'expectedTotalRef.current:', expectedTotalRef.current, 'batchTaskLength:', batchTaskLength, 'transcriptsForBatch.current.length:', transcriptsForBatch.current.length);  
  //   if(linkQueue.length <= 0 && expectedTotalRef.current > 0) {
  //       if (transcriptsForBatch.current.length === expectedTotalRef.current && batchTaskLength === expectedTotalRef.current) {
  //         setProgressStatus('Batch procesing');
  //         const batchData = [...transcriptsForBatch.current];
  //         startGPTBatch(batchData);
  //         const batchORNOT = true;
  //         resetAllValues(batchORNOT);
  //       }
  //   }
  // }, [linkQueue, batchTaskLength]);

  useEffect(() => {
    console.log('linkQueue.length:', linkQueue.length, 
                'expectedTotalRef.current:', expectedTotalRef.current, 
                'batchTaskLength:', batchTaskLength, 
                'transcriptsForBatch.current.length:', transcriptsForBatch.current.length);  
    
    // 确保只有在批处理模式且队列为空时才进行批处理启动
    if (linkQueue.length === 0 && expectedTotalRef.current > 0) {
      // 添加额外验证，确保收集了正确数量的transcript
      if (transcriptsForBatch.current.length > 0 && 
          transcriptsForBatch.current.length === expectedTotalRef.current && 
          batchTaskLength === expectedTotalRef.current) {
        
        console.log("Start batch processing, including ", transcriptsForBatch.current.length, " tasks.");
        setProgressStatus('Batch processing');
        const batchData = [...transcriptsForBatch.current]; // 创建副本防止引用问题
        
        // 在启动批处理前先重置状态，防止队列被错误处理
        const tempExpected = expectedTotalRef.current;
        expectedTotalRef.current = 0; // 立即重置，防止重复触发
        
        startGPTBatch(batchData);
        
        // 延迟重置其他状态，确保批处理已启动
        setTimeout(() => {
          const batchORNOT = true;
          resetAllValues(batchORNOT);
        }, 100);
      }
    }
  }, [linkQueue, batchTaskLength]);

  useEffect(() => {
    if (queueBusyRef.current || linkQueue.length === 0) {
      console.log('Line 374: queueBusyRef.current:', queueBusyRef.current, 'linkQueue.length:', linkQueue.length);
      return;
    }
    //expectedTotalRef.current  transcriptsForBatch.current.length 
    if(!error) {
      // setMessageShowToUser(`Processing the ${expectedTotalRef.current - linkQueue.length + 1}/${expectedTotalRef.current}th file.`);
    } else {
      setMessageShowToUser('Processing the video link, please wait.');
    }
    console.log('Line 383: linkQueue:', linkQueue);

    const nextURL = linkQueue[0];
    queueBusyRef.current = true;

    (async () => {
      const decision = await decideHowToProcess(nextURL);

      switch (decision.mode) {
        case "invalid":
          // setError("Invalid link: " + nextURL); 
          expectedTotalRef.current -= 1;
          cancelledBatchTasksRef.current.push({ url: nextURL, error: "Invalid link" });
          queueBusyRef.current = false;
          setLinkQueue(q => q.slice(1));
          break;

        case "skip_done":
          expectedTotalRef.current -= 1;
          cancelledBatchTasksRef.current.push({ url: nextURL, error: decision.error });
          queueBusyRef.current = false;
          setLinkQueue(q => q.slice(1));
          break;
        
        case "resume":
          expectedTotalRef.current -= 1;
          cancelledBatchTasksRef.current.push({ url: nextURL, error: decision.error });
          queueBusyRef.current = false;
          setLinkQueue(q => q.slice(1));
          break;

        // case "skip_cached":
        //   pushTranscriptForBatch({ id: nextURL, transcript: decision.transcript, noteIDnum: gereatedUniqueNoteID(), videoURL: url, videoID: decision.videoId });
        //   break;

        // case "resume":
        //   setProgressStatus("Transcribing");
        //   setIsTranscribing(true);
        //   (async () => {
        //     const data = await waitForTranscript(decision.taskId);
        //     pushTranscriptForBatch({ id: nextURL, transcript: data.transcriptionText, noteIDnum: decision.noteIDnum || gereatedUniqueNoteID(), videoURL: url, videoID: decision.videoId, subtitleWithTimestamp: data.subtitleWithTimestamp });
        //   })();
        //   break;

        case "transcribe":
          await testVideoLinkPaste(nextURL);   // 复用原函数；当完成时会走 updateTranscription → pushTranscriptForBatch (见下)
          break;

        default:
          break;
      }

      // 移出队列
      // setLinkQueue(q => q.slice(1));
      // queueBusyRef.current = false;
    })();
  }, [linkQueue]);

  /* ------------------ 当 updateTranscription 完成且 text 不为空 → push ------------------ */
  const pushTranscriptForBatch = async (metaObj) => {
    const { id, transcript, videoURL } = metaObj;
    if (!id || !transcript) return;
    
    console.log(`Add processing results to batch queue: ID=${id}, URL=${videoURL}`);

    const idx = transcriptsForBatch.current.findIndex(t => t.id === id);
    if (idx === -1) {
      if (transcript) {
        transcriptsForBatch.current.push(metaObj);
        setBatchTaskLength(transcriptsForBatch.current.length);
        console.log(`Add new tasks to batch queue, currently ${transcriptsForBatch.current.length} tasks.`);
      }
    } else {
      const old = transcriptsForBatch.current[idx];
      if (old.transcript === "Transcript updating..." || old.transcript !== transcript) {
        if (transcript !== "Transcript updating...") {
          transcriptsForBatch.current[idx] = metaObj; // 覆盖
          console.log(`Update task in batch queue: index=${idx}`);
        }
      }
    }

    // 释放队列锁并移除当前URL
    if(idx === -1) {
      console.log('Complete current URL processing, remove from queue');
      queueBusyRef.current = false;
      setLinkQueue(q => q.slice(1));
    }
  };
  // —————————————————————————————————————————————————
  /* ------------------ 重写 updateTranscription (增加 push) ------------------ */
  const updateTranscription = (
    newText, id, url, polishedText, videoURL, videoID,
    duration, title, noteIDnum, subtitleWithTimestamp
  ) => {
    const noteIDnumOK = noteIDnum || gereatedUniqueNoteID();
    if(expectedTotalRef.current === -1 || expectedTotalRef.current === -2) {
      setTranscription({
        text: newText,
        transcribeID: id,
        url: url,    //AudioUrl
        PolishedText: polishedText,
        videoURL,
        videoID,
        duration,
        title,
        noteIDnum: noteIDnumOK,
        subtitleWithTimestamp
      });
    } else {
      if (newText) {
        pushTranscriptForBatch({ 
          id: videoID, 
          transcript: newText, 
          noteIDnum: noteIDnumOK,
          transcribeID: id, 
          url, 
          videoURL, 
          videoID, 
          duration, 
          endTime: Date.now(), 
          realtimeBoolValue: false, 
          polishedText, 
          title, 
          subtitleWithTimestamp });
      }
    }
  };

  const convertMp3ToWavBuffer = async (mp3blob) => {
    if (!mp3blob) {
      setError("MP3 file format error. Please upload a valid MP3 file.");
      return null;
    }
    const arrayBuffer = await mp3blob.arrayBuffer();
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const originalBuffer = await audioContext.decodeAudioData(arrayBuffer);
  
    let audioChannels = await getAudioChannels(mp3blob);
    if (audioChannels === 1) {
      const wavArrayBuffer = toWav(originalBuffer, 48000);
      const buffer = Buffer.from(wavArrayBuffer);
      return buffer;
    }
    // 创建一个新的单声道 AudioBuffer 对象
    const monoBuffer = audioContext.createBuffer(1, originalBuffer.length, originalBuffer.sampleRate);
  
    // 将原音频数据的左声道复制到新的 AudioBuffer 对象中
    const originalData = originalBuffer.getChannelData(0);
    const monoData = monoBuffer.getChannelData(0);
    for (let i = 0; i < originalBuffer.length; i++) {
      monoData[i] = originalData[i];
    }
  
    const wavArrayBuffer = toWav(monoBuffer, 48000);
    const buffer = Buffer.from(wavArrayBuffer);
  
    return buffer;
  };
  //______________________________________________________________
  // 2025.05.03 m4a转 mp3
  // async function validateAndConvert(file) {
  //   if (!ffmpeg.isLoaded()) await ffmpeg.load();
  
  //   const inputFileName = 'input.m4a';
  //   const outputFileName = 'output.mp3';
  
  //   ffmpeg.FS('writeFile', inputFileName, await fetchFile(file));
  
  //   // 获取音频信息
  //   try {
  //     await ffmpeg.run('-i', inputFileName);
  //   } catch (e) {
  //     // ffmpeg.run 会抛出错误，但我们可以从 stderr 获取信息
  //   }
  
  //   const infoText = ffmpeg.stderr;
  
  //   // 检查是否为单声道、48kHz 采样率和 AAC 编码
  //   const isMono = /Audio:.*mono/.test(infoText);
  //   const is48kHz = /48000 Hz/.test(infoText);
  //   const isAAC = /Audio: aac/.test(infoText);
  
  //   if (isMono && is48kHz && isAAC) {
  //     console.log('文件符合 Azure 要求');
  //     return file;
  //   }
  
  //   // 转码为 MP3 格式
  //   await ffmpeg.run(
  //     '-i', inputFileName,
  //     '-ac', '1',
  //     '-ar', '48000',
  //     '-b:a', '128k',
  //     outputFileName
  //   );
  
  //   const data = ffmpeg.FS('readFile', outputFileName);
  
  //   // 转为 Blob 以便上传
  //   const blob = new Blob([data.buffer], { type: 'audio/mp3' });
  //   return new File([blob], outputFileName, { type: 'audio/mp3' });
  // }
  //______________________________________________________________
  //2025.05.05 apple 编码 m4a转 mp3
  async function checkAndConvertAudio(file) {
    await ffmpeg.load();
    setProgressOfPrecheck(10);
    // 日志缓存
    let logs = [];
    // 订阅日志事件
    ffmpeg.on('log', ({ message }) => {
      logs.push(message);
    });
  
    const inputName  = 'input.m4a';
    const outputName = 'output.mp3';
  
    // 写入文件系统
    await ffmpeg.writeFile(inputName, await fetchFile(file));
    setProgressOfPrecheck(25);
  
    // 先清空旧日志，再执行 probe
    logs = [];
    try {
      // 这里只是用来填充 logs，不关心返回值
      await ffmpeg.exec(['-i', inputName]);
    } catch (e) {
      // probe 会返回非零退出码，抛异常是正常的
    }
    const infoText = logs.join('\n');
    setProgressOfPrecheck(40);
  
    // 用正则从 infoText 里解析
    const isMono    = /Audio:.*mono/.test(infoText);
    const is48kHz   = /48000 Hz/.test(infoText);
    const isAAC     = /Audio: aac/.test(infoText);
    const brMatch   = /bitrate: (\d+)/.exec(infoText);
    const bitRate   = brMatch ? parseInt(brMatch[1], 10) : 0;
  
    // 检查是否满足——单声道、48kHz、AAC、>=95kbps
    const isValid = isMono && is48kHz && isAAC && bitRate >= 95000;
    setProgressOfPrecheck(50);
  
    if (isValid) {
      console.log('✅ The file does not meet Azure requirements.');
      setProgressOfPrecheck(100);
      return file;
    }
    
    setProgressOfPrecheck(60);
    console.log('⚠️ The file does not meet the requirements and is converted to MP3...');
    ffmpeg.on('progress', ({ ratio }) => {
      // ratio 从 0 到 1，对应 60-90%
      setProgressOfPrecheck(60 + Math.floor(ratio * 30));
    });
    // 转码
    await ffmpeg.exec([
      '-i',  inputName,
      '-ac', '1',
      '-ar', '48000',
      '-b:a','128k',
      outputName
    ]);
    setProgressOfPrecheck(95);
  
    // 读取转码结果
    const data = await ffmpeg.readFile(outputName);
    setProgressOfPrecheck(100);
    return new File([data.buffer], outputName, { type: 'audio/mp3' });
  }
  //______________________________________________________________
  // 2025.04.22 检查并更新使用时长
  const checkAndUpdateTimeUsage = (Duration) => {
    // 计算使用时长，以分minute为单位
    let MAX_USAGE;
    if (userVipLevel === 0) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_FREE;
    } else if (userVipLevel === 1) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP1;
    } else if (userVipLevel === 2) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP2;
    }
    // let useageTotal = 0;
    // let usage = Duration / 60; // 转换为分钟
    // usage = Math.round(usage * 100) / 100;
    // useageTotal = currentUsageTimeTotalRef.current || userDataLocal?.Usage?.time || 0 + usage;

    let usage = Math.round((Duration / 60) * 100) / 100;
  
    // 修正：先取一个基准时长，再加上本次 usage
    const base = currentUsageTimeTotalRef.current || userDataLocal?.Usage?.time || 0;
    const usageTotal = base + usage;
    console.log('usageTotal:', usageTotal, 'currentUsageTimeTotalRef.current:', currentUsageTimeTotalRef.current, 'userDataLocal?.Usage?.time:', userDataLocal?.Usage?.time, 'MAX_USAGE:', MAX_USAGE);
    if (usageTotal > MAX_USAGE) {
      if(expectedTotalRef.current === -1 || expectedTotalRef.current === 1) {
        upgradeUserLevel(true); //如果是单个链接或者批量处理的最后一个链接，当usage超标之后需要升级用户等级
        setCompletedAllOfFiles(true);
        setLinkQueue([]);
        setTimeout(() => {
          handleClose();
        }, 10000);
      }
      return false;
    } else {
      currentUsageTimeTotalRef.current = usageTotal;
      return true;
    }
  };
  //______________________________________________________________

  const handleUrlChange = (e) => {
    setVideoURLAddressTemp(e.target.value);
    setUserCancleTranscribe(false);
  };

  const extractVideoId = (url) => {
    try {
      // 支持的URL格式：
      // - https://www.youtube.com/watch?v=VIDEO_ID
      // - https://youtu.be/VIDEO_ID
      // - https://www.youtube.com/embed/VIDEO_ID
      const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
      const match = url.match(regex);
      return match ? match[1] : null;
    } catch (error) {
      console.error('Error extracting video ID:', error);
      return null;
    }
  };

  const extractLanguageCode = (url) => {
    try {
      const urlObj = new URL(url);
      return urlObj.searchParams.get('lan');
    } catch (error) {
      // console.error('无效URL:', error);
      return null;
    }
  };

  /* ------------------ 修改 handleUrlArrayPreProcess ------------------ */
  const handleUrlArrayPreProcess = () => {
    if (!videoURLAddressTemp) return;
  
    if (videoURLAddressTemp.includes(",") ||
        videoURLAddressTemp.includes("，") ||
        /\s/.test(videoURLAddressTemp)
    ) {
      if (expectedTotalRef.current > 0) {
        setError('Please wait for the current batch to finish.');
        return;
      }
  
      // 按英文逗号、中文逗号、任意空白符分割，去掉空项，并去重
      const vids = Array.from(new Set(
        videoURLAddressTemp
          .split(/[,\uFF0C\s]+/)
          .map(s => s.trim())
          .filter(Boolean)
      ));
  
      expectedTotalRef.current = vids.length;
      setLinkQueue(vids);
      setVideoURLAddressTemp("");
    } else {
      // 单链接：原有流程
      expectedTotalRef.current = -1;
      testVideoLinkPaste(videoURLAddressTemp);
    }
  };

  const testVideoLinkPaste = async (videoURLAddressTemp) => {
    updateTranscription('', '', '', '', '', '', 0, '', '', '');
    console.log('Line 614: videoURLAddressTemp:', videoURLAddressTemp);
    setIsTranscribing(false);
    //videoURLAddressTemp = 'https://www.youtube.com/watch?v=IPcuLtBX_sg&lan=zh-CN';
    const videoUrl = videoURLAddressTemp //prompt('Please paste the video URL here:');
    const langCodeUserSet = extractLanguageCode(videoUrl); // 返回 'zh-CN'
    const videoId = extractVideoId(videoUrl);
    setError(null);
    setVideoURLAddressTemp('');
    if (!videoUrl || !videoId ) {
      setIsPreCheckingAudioFile(false);
      setError('Invalid video link'); 
      return;
    }
    const noteInUserDataLocal = userDataLocal.History.find(item => item.videoID === videoId);
    if (noteInUserDataLocal) {
      setError('This video has been transcribed before. Please check your history. It maybe created at ' + noteInUserDataLocal.date + '. You can view it by clicking the Transcript button below.');
      setNoteExist(noteInUserDataLocal);
      setIsPreCheckingAudioFile(false);
      return;
    } else {
      setNoteExist(null);
    }
    setIsPreCheckingAudioFile(false);
    setUploading(true);
    if (expectedTotalRef.current === -1) {
      setMessageShowToUser('Processing the video link, please wait.');
    } else {
      setMessageShowToUser(`Processing the ${expectedTotalRef.current - linkQueue.length + 1}/${expectedTotalRef.current + cancelledBatchTasksRef.current.length}th file, please wait`);
    }
    // setIsPreCheckingAudioFile(true);
    
    setFileName('Video URL');
    setProgressStatus('Validating');

    //fetch video data from a tabel in Firestore
    const videoData = await getVideoData(videoId, videoUrl);
    
    if (userCancleTranscribeRef.current && expectedTotalRef.current === -1) {
      setUploading(false);
      setProgressStatus('Cancelled');
      setIsPreCheckingAudioFile(false);
      // console.log('Line 417: videoData:', videoData);
      return;
    }

    // console.log('Line 423: videoData:', videoData);
    let noteIDnum = gereatedUniqueNoteID();
    if (videoData) {
      const { Duration, Language, PolishedText, Title, Transcript, AudioUrl, TranscribeID, AudioUploaded, subtitleWithTimestamp } = videoData;
      console.log('Duration:', Duration);
      if (Math.floor(Duration) > 0 && !checkAndUpdateTimeUsage(Math.floor(Duration))) {
        // setUsageOverMaxset(true);
        setMessageShowToUser('You have exceeded the maximum usage time. Please upgrade your account.');
        if(expectedTotalRef.current > 0) {
          expectedTotalRef.current -= 1;
          cancelledBatchTasksRef.current.push({ url: videoUrl, error: "Usage time exceeded" });
          queueBusyRef.current = false;
          setLinkQueue(q => q.slice(1));
        } else {
          setUploading(false);
          setProgressStatus('Failed');
        }
        setIsPreCheckingAudioFile(false);
        return;
      }
      // setUploadedFileName(audioUrl.split('/').pop());
      setDuration(Math.floor(Duration));
      setFileName(Title);
      if(Transcript) {
        setUploading(false);
        setIsPreCheckingAudioFile(false);
        setError(null);
        setProgressOfTranscription(100);
        setProgressStatus('Updating');
        setIsUpdatingHistory(true);
        setTimeout(() => {
          updateTranscription(Transcript, TranscribeID, AudioUrl, PolishedText, videoUrl, videoId, Duration, Title, noteIDnum, subtitleWithTimestamp);
        }, 100);
        setTimeout(() => {
          setIsTranscribing(false);
        }, 200);
      } else if(TranscribeID) {
        setUploading(false);
        setIsPreCheckingAudioFile(false);
        setError(null);
        setProgressStatus('Transcribing');
        setIsTranscribing(true);
        //此处没有noteIDnum, 因为数据是从云端获得的，不需要新建noteIDnum
        currentTranscriptionTaskID = TranscribeID;
        createHistoryRecord(TranscribeID, AudioUrl, videoUrl, videoId, duration, Title);
        checkTranscriptionStatus(TranscribeID, AudioUrl, videoUrl, videoId, Duration, Title);
      } else if(!AudioUrl && AudioUploaded && (AudioUploaded === 'uploading' || AudioUploaded === 'initialization' || AudioUploaded === 'failed')) {
        console.log("The video data exists, but no subtitles are found, the transcription result is null, and the audio does not seem to have been uploaded yet. Continue waiting for the audio upload result.");
        if (userCancleTranscribeRef.current && expectedTotalRef.current === -1) {
          setUploading(false);
          setProgressStatus('Cancelled');
          setIsPreCheckingAudioFile(false);
          return;
        }
        const durationValue = Duration;
        await handleUpload(videoId, videoUrl, Title, durationValue, AudioUploaded);
      } else if(AudioUrl && (AudioUploaded === 'uploaded')) {
        setUploading(false);
        setIsPreCheckingAudioFile(false);
        setError(null);
        console.log("The video data exists, but no subtitles are found, the transcription result is null, and the audio has been uploaded. Start transcribing.");
        if (userCancleTranscribeRef.current && expectedTotalRef.current === -1) {
          setUploading(false);
          setProgressStatus('Cancelled');
          setIsPreCheckingAudioFile(false);
          return;
        }
        setVideoURLAddress({
          videoURL: videoUrl,
          videoID: videoId,
          audioURL: AudioUrl,
          title: Title, 
          duration: Duration,
          noteIDnum: noteIDnum,
          lancode: Language
        });
        setUploadedFileName(AudioUrl.split('/').pop());
        setUploading(false);
        setError(null);
      }
      
    } else {
      // get video title, duration, lancode and subtitles from the video link
      const { 
        title,
        duration,
        lancode,
        subtitles,
        subtitleWithTimestamp
        } = await getVideoTitle(videoUrl);      
      console.log('duration:', duration);
      if (Math.floor(duration) > 0 && !checkAndUpdateTimeUsage(Math.floor(duration))) {
        // setUsageOverMaxset(true);
        setMessageShowToUser('You have exceeded the maximum usage time. Please upgrade your account.');
        if(expectedTotalRef.current > 0) {
          expectedTotalRef.current -= 1;
          cancelledBatchTasksRef.current.push({ url: videoUrl, error: "Usage time exceeded" });
          queueBusyRef.current = false;
          setLinkQueue(q => q.slice(1));
        } else {
          setUploading(false);
          setProgressStatus('Failed');
        }
        setIsPreCheckingAudioFile(false);
        return;
      }
      
      const lancodeOK = langCodeUserSet || lancode;
      setFileName(title);
      setDuration(Math.floor(duration));
      // console.log('language:', lancode, 'subtitles:', subtitles);
      if (subtitles && lancode) { 
        // console.log(`Subtitles received, it's language is: ${lancode}`);
        setUploading(false);
        setIsPreCheckingAudioFile(false);
        setError(null);
        setProgressOfTranscription(100);
        setProgressStatus('Updating');
        setIsUpdatingHistory(true);
        setTimeout(() => {
          updateTranscription(subtitles, 'Done', '', '', videoUrl, videoId, duration, title, noteIDnum, subtitleWithTimestamp);
        }, 100);
        setTimeout(() => {
          setIsTranscribing(false);
        }, 200);
        if (videoId && videoUrl) {
          const newVideoData = { 
            Duration: duration, 
            Language: lancodeOK, 
            PolishedText: '', 
            Title: title, 
            Transcript: subtitles, 
            AudioUrl: '', 
            TranscribeID: 'Done',
            VideoUrl: videoUrl,
            AudioUploaded: 'uploaded',
            subtitleWithTimestamp: subtitleWithTimestamp
          }
          // console.log('newVideoData:', newVideoData);
          updateVideoData(videoId, newVideoData);
        }
      } else {
        const AudioUploaded = 'initialization';
        if(title && title !== 'Unknown Video' && duration > 0) { 
          // setMessageShowToUser('Processing the video link, please wait');
          if (videoId && videoUrl) {
            const newVideoData = { 
              Duration: duration, 
              Language: lancodeOK, 
              PolishedText: '', 
              Title: title, 
              Transcript: '', 
              AudioUrl: '', 
              TranscribeID: '',
              VideoUrl: videoUrl,
              AudioUploaded: AudioUploaded,
              subtitleWithTimestamp: ''
            }
            // console.log('newVideoData:', newVideoData);
            updateVideoData(videoId, newVideoData);
          }
        } else {
          setUploading(false);
          setProgressStatus('Failed');
          setMessageShowToUser('Invalid video link or video is private, please check the video link and try again.');
          if(expectedTotalRef.current > 0) {
            expectedTotalRef.current -= 1;
            cancelledBatchTasksRef.current.push({ url: videoUrl, error: "Invalid video link or video is private." });
            queueBusyRef.current = false;
            setLinkQueue(q => q.slice(1));
          }
          setIsPreCheckingAudioFile(false);
          return;
        }
        console.log("No subtitles found, starting transcription");
        if (userCancleTranscribeRef.current && expectedTotalRef.current === -1) {
          // console.log('Line 554 quit.');
          setUploading(false);
          setProgressStatus('Cancelled');
          setIsPreCheckingAudioFile(false);
          return;
        }
        const durationValue = duration;
        setIsPreCheckingAudioFile(false);
        setError(null);
        await handleUpload(videoId, videoUrl, title, durationValue, AudioUploaded, lancodeOK);
      }
    }
  };

  const getVideoTitle = async (videoUrl, videoId) => {
    let retries = 0;
    const maxRetries = 5;
  
    while (retries <= maxRetries) {
      // 每次尝试时创建一个新的 AbortController 和超时定时器
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 300000); // 60秒超时
  
      console.log(`Start requesting video information (Attempt ${retries + 1}/${maxRetries + 1}): ${videoUrl}`);
  
      try {
        const response = await axios.post(
          '/api/getVideoTitle',
          { videoUrl },
          {
            signal: controller.signal,
            timeout: 300000, // 与上面的超时保持一致
            headers: {
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache'
            }
          }
        );
  
        clearTimeout(timeoutId);
        console.log('Successfully obtained video information:', response.data);
  
        // 验证响应数据是否完整
        if (!response.data || !response.data.title) {
          throw new Error('The response data is incomplete');
        }
        
        return response.data;
      } catch (error) {
        clearTimeout(timeoutId);
        console.log(`Attempt ${retries + 1}/${maxRetries + 1} failed:`, error.message);
  
        // 如果已达到最大重试次数，或者遇到AbortError/ECONNABORTED则退出重试
        if (retries === maxRetries ||
            error.name === 'AbortError' ||
            error.code === 'ECONNABORTED') {
          console.error('Max retries reached or abort/timeout error encountered');
          return { title: 'Unknown Video', duration: 0, transcript: '' };
          // throw error;
        }
        
        retries++;
        console.log(`Retrying to obtain video information: Attempt ${retries + 1}/${maxRetries + 1}`);
        // 延长等待时间，采用指数回退策略
        await new Promise(resolve => setTimeout(resolve, 2000 * retries));
      }
    }
  
    // 如果所有重试均失败，设置默认返回值
    console.error('Failed to obtain video information after all retries.');
    setDuration(0);
    
    // 更详细的错误分类处理可以放在这里
    return { title: 'Unknown Video', duration: 0, transcript: '' };
  };

  const handleFileChange = async (e) => {
    // const file = e.target.files[0];
    // if (!file) return;

    const newFiles = Array.from(e.target.files);
    const audioFiles = newFiles.filter(file => file.type.startsWith('audio/'));
    if (uploading) {
      setError('File is still uploading. Please wait.');
      return;
    }

    if (audioFiles.length < 1) {
      return;
    }
    setAudioFileUserUploadArray([...audioFileUserUploadArray, ...audioFiles]);
    setSumOFSelectedFiles(oldValue => oldValue + audioFiles.length);
  };

  const preCheckAudioFile = async (file) => {

    setFileName(file.name);
    setIsPreCheckingAudioFile(true);
    setUserCancleTranscribe(false);
    setNoteExist(null);
    setProgressStatus('Checking');
    setProgressOfPrecheck(0);
    // console.log('file.type:', file.type);
    if (allowedFormats.includes(file.type)) {
      const duration = await getAudioDuration(file);
      // console.log('duration:', duration);
      setDuration(Math.floor(duration));
      setError(null);
      if (/^audio\/(mp4|x-m4a)$/.test(file.type) || file.name.toLowerCase().endsWith('.m4a')){
        // const fileOK = await validateAndConvert(file); 
        const fileOK = await checkAndConvertAudio(file);
        if (!fileOK) {
          setError("File format error. Please upload a valid audio file.");
          setProgressStatus('Failed');
          setDuration(0);
          setAudioFileUserUpload(null);
          return;
        } else {
          setAudioFileUserUpload(fileOK);
        }
      } else {
        setAudioFileUserUpload(file);
      }
      // setAudioFileUserUpload(file);
    } else {
      if (audioFileUserUploadArray.length > 0) {
        setAudioFileUserUploadArray(prevArray => prevArray.slice(1));
      }
      // console.error("Unsupported file type");
      setError("Unsupported file type");
      setProgressStatus('Failed');
      setDuration(0);
      setAudioFileUserUpload(null);
    }
  };

  function handleClose () {
    setIsVisibleSTT(false);
    if(completedAllOfFiles && linkQueue.length === 0) {
      onClose(true);
      setUpdatedSuccessfully(false);
    } else {
      onClose(false);
    }
  }


  const handleDrop = (e) => {
    e.preventDefault();
    if (uploading) {
      setError('File is still uploading. Please wait.');
      return;
    }
    let validFiles = [...audioFileUserUploadArray];
    if (e.dataTransfer.items) {
      for (let i = 0; i < e.dataTransfer.items.length; i++) {
        if (e.dataTransfer.items[i].kind === 'file') {
          const file = e.dataTransfer.items[i].getAsFile();
          const fileType = file.type.toLowerCase();
          if (fileType.startsWith('audio/') || allowedFormats.includes(fileType)) { // 只接受音频文件
            // const pseudoEvent = { target: { files: [file] } };
            // handleFileChange(pseudoEvent);
            validFiles.push(file);
            setError(null);
          } else {
            setError(`${file.name} is a invalid file. Please upload an audio file.`);
          }
        }
      }
    }
    setAudioFileUserUploadArray(validFiles);
    setSumOFSelectedFiles(oldValue => oldValue + validFiles.length);
  };

  // _______________________________________________________________________________________
  //2025.02.24
  
  const calculateFileHash = async (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const sparkMD5 = require('spark-md5');
        const hash = sparkMD5.ArrayBuffer.hash(e.target.result);
        resolve(hash);
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const handleUploadResumeMode = async (file, noteIDnum, retryCount = 0) => {
    try {
      const fileHash = await calculateFileHash(file); // 获取文件的唯一标识（哈希值）
      // console.log('fileHash', fileHash);
      const totalChunks = Math.ceil(file.size / CHUNK_SIZE); // 计算文件分片总数
      // 检查哪些分片已经上传
      const { data: checkData } = await axios.post(
        '/api/check',
        {
          fileName: file.name,
          fileHash,
        },
      );

      // 用 Set 存储已上传分片索引，便于查找
      const uploadedChunks = new Set(checkData.uploadedChunks || []);

      // 上传未完成的分片
      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        if (uploadedChunks?.has(chunkIndex)) {
          console.log('Pass chunkIndx', chunkIndex);
          setProgressOfUpload(((chunkIndex + 1) / totalChunks) * 100); // 更新进度
          continue; // 跳过已经上传的分片
        }
        console.log('Upload chunkIndx: ', chunkIndex, 'Total chunks: ', totalChunks);
        // 创建当前分片
        const start = chunkIndex * CHUNK_SIZE; // 分片起始字节
        const end = Math.min(file.size, start + CHUNK_SIZE); // 分片结束字节
        const chunk = file.slice(start, end); // 获取分片
        let success = false;
        let attempts = 0;

        // 对每个分片重试上传
        while (!success && attempts < MAX_RETRY) {
          try {
            // 上传分片
            const formData = new FormData();
            // formData.append('chunk', chunk); // 当前分片
            formData.append('fileName', file.name); // 文件名
            formData.append('fileHash', fileHash); // 文件唯一标识
            formData.append('chunkIndex', chunkIndex); // 分片索引
            formData.append('chunk', chunk);

            await axios.post(
              `/api/upload?fileHash=${fileHash}&chunkIndex=${chunkIndex}&fileName=${file.name}`,
              formData,
              {
                onUploadProgress: (progressEvent) => {
                  const chunkProgress = progressEvent.loaded / progressEvent.total;
                  const overallProgress = ((chunkIndex + chunkProgress) / totalChunks) * 100;
                  setProgressOfUpload(overallProgress);
                },
              },
            );
            // 上传成功后标记该分片
            uploadedChunks.add(chunkIndex);
            success = true;
          } catch (err) {
            attempts++;
            console.error(`Upload of chunk ${chunkIndex} failed for ${attempts} times:`, err);
            // 重试前延时（可采用指数退避）
            await new Promise(resolve => setTimeout(resolve, 1000 * attempts));
          }
        }
        if (!success) {
          alert(`Chunk ${chunkIndex} upload failed, please check the network and try again!`);
          uploading.current = false;
          return;
        }
      }

      // 通知服务端合并分片
      const mergeResponse = await axios.post('/api/merge', {
        fileName: file.name,
        fileHash,
        totalChunks,
        userid: user.uid, 
        noteIDnum
      });

      // console.log('Upload successfully, url is:', mergeResponse.data.url);
      return mergeResponse.data.url;
    } catch (err) {
      console.error('Error in uploading chunks: ', err);
      if (retryCount < MAX_RETRY) {
        console.log(`Retrying handleUploadResumeMode, attempt ${retryCount + 1}`);
        return handleUploadResumeMode(file, noteIDnum, retryCount + 1);
      } else {
        console.error('Max retry attempts reached. Upload failed.');
        return null;
      }
    }
  };
  // _______________________________________________________________________________________

  const handleUpload = async (videoId, videoUrl, title, durationValue, AudioUploaded, lancode) => {
    // console.log('handleUpload is running');

    if (userCancleTranscribeRef.current && expectedTotalRef.current === -1) {
      // console.log('HandleUpload quit.');
      setUploading(false);
      setProgressStatus('Cancelled');
      return;
    }

    
    setIsPreCheckingAudioFile(false);
    
    updateTranscription('', '', '', '', '', '', 0, '', '', '');

    let durationTime = duration > 0 ? duration : 60; // 默认音频时长为 60 秒
    if (durationValue &&  durationValue > 0) {
      durationTime = durationValue;
    }

    const usageSum = Math.round(durationTime / 60 * 100) / 100;

    let noteIDnum = gereatedUniqueNoteID();

    if (!audioFileUserUpload && !videoUrl) {
        setError('Please select a file first');
        return;
    }
    console.log('Start uploading audio file...');
    setError(null);
    if(audioFileUserUpload && !videoUrl) {
      if (Math.floor(durationTime) > 0 && !checkAndUpdateTimeUsage(Math.floor(durationTime))) {
        // setUsageOverMaxset(true);
        setError('You have exceeded the maximum usage time. Please upgrade your account.');
        setUploading(false);
        setProgressStatus('Failed');
        return;
      }
      setProgressStatus('Uploading');
      setUploading(true);
      const formData = new FormData();
      // const fileName = user.uid + '-_-' + audioFileUserUpload.name; // 指定文件名
      const fileName = audioFileUserUpload.name;
      formData.append('audio', audioFileUserUpload, fileName);
      // 添加检查：确保 formData 包含 audio 字段

      await checkToken();
      // console.log('fileName is:', fileName);
      // console.log('formData:', formData);
      // console.log('Uploading file, userid is:', userid);
      // 添加超时配置（单位：毫秒）
      const uploadTimeout = durationTime * 1000 * 2; // 2倍音频时长
      const cancelToken = axios.CancelToken.source();

      // 添加超时计时器
      const timeoutId = setTimeout(() => {
        cancelToken.cancel('Upload timeout');
      }, uploadTimeout);

      let response = null;
      let urlTemp = '';
      try {
        if(true) {
          urlTemp = await handleUploadResumeMode(audioFileUserUpload, noteIDnum);
        } else {
          response = await axios.post('/api/upload', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
              const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              setProgressOfUpload(progress);
            },
          });
        }

        clearTimeout(timeoutId);
        // setUrl(response.data.url);
        // setProgressStatus('Done');
        // console.log('Audio upload done, it\'s url is:', response?.data?.url || urlTemp);
        console.log('Audio upload done');
        setUploading(false);
        setError('');
        setUploadedFileName(response?.data?.url.split('/').pop() || urlTemp?.split('/').pop() || '');

        const audioName = urlTemp.split('/').pop() || audioFileUserUpload.name;
        let audioUrl = urlTemp;
        if (!urlTemp.includes(noteIDnum)) audioUrl = await handleRenameUploadedAudioFile(audioName, noteIDnum);  
        setVideoURLAddress({
          videoURL: '',
          videoID: '',
          audioURL: audioUrl,
          title: '',
          duration: duration,
          noteIDnum: noteIDnum,
          lancode: lancode
        });
        // console.log('response.data.url is:', response.data.url);
        setUploading(false);
        setError(null);
        // return {
        //   audioUrl: audioUrl,
        //   noteIDnum: noteIDnum
        // };
        
        // const urlTemp = response.data.url;

        // const audioName = urlTemp.split('/').pop();
        // const audioUrl = await handleRenameUploadedAudioFile(audioName, noteIDnum);  

        // //setUrl(response.data.url);
        // //const audioUrl = response.data.url;
        // setVideoURLAddress({
        //   videoURL: '',
        //   videoID: '',
        //   audioURL: audioUrl,
        //   title: '',
        //   duration: duration,
        //   noteIDnum: noteIDnum
        // });
        // setUploadedFileName(response.data.url.split('/').pop());
        // // console.log('response.data.url is:', response.data.url);
        // setUploading(false);
        // setError(null);
      } catch (err) {
        if (axios.isCancel(err)) {
          console.log('Upload cancelled:', err.message);
        }
        setError('Error uploading the file');
        console.error('Error uploading the file, error detail is: ', err);
        setUploading(false);
        setProgressStatus('Failed');
        // setUploadedFileName('');
      }
    } else if (videoUrl && videoUrl !== '') {
      setProgressStatus('Converting');
      const uid = user.uid;
      const audioUrl = await getAudioUrlOfVideo(videoId, videoUrl, noteIDnum, uid, AudioUploaded, durationTime);
      if (userCancleTranscribeRef.current && expectedTotalRef.current === -1) {
        // console.log('HandleUpload quit.');
        setUploading(false);
        setProgressStatus('Cancelled');
        return;
      }
      if (!audioUrl) {
        setError('Error uploading the file');
        setUploading(false);
        setProgressStatus('Failed');
        setVideoURLAddress({
          videoURL: '',
          videoID: '',
          audioURL: '',
          title: '',
          duration: 0,
          noteIDnum: '',
          lancode: ''
        });
        const newVideoData = { 
          AudioUrl: '', 
          AudioUploaded: 'failed'
        }
        updateVideoData(videoId, newVideoData);
        if(expectedTotalRef.current > 0) {
          expectedTotalRef.current -= 1;
          cancelledBatchTasksRef.current.push({ url: videoUrl, error: "Error uploading the file" });
          queueBusyRef.current = false;
          setLinkQueue(q => q.slice(1));
        }
        return;
      }
      setVideoURLAddress({
        videoURL: videoUrl,
        videoID: videoId,
        audioURL: audioUrl,
        title: title, 
        duration: durationValue,
        noteIDnum: noteIDnum,
        lancode: lancode
      });
      setUploadedFileName(audioUrl.split('/').pop());
      setUploading(false);
      setError(null);
      return;
    }
  };

  const getAudioUrlOfVideo = async (videoId, videoUrl, noteIDnum, uid, AudioUploaded, durationTime) => {
    setProgressOfUpload(5);
    let retries = 0;
    // const maxRetries = durationTime/(60 * 5) > 3 ? durationTime/(60 * 5) : 3;  
    const maxRetries = Math.ceil(durationTime/(60 * 5) > 3 ? durationTime/(60 * 5) : 3); //120分钟的视频需要重试24次，但是在第一次启动上传的时候都有一个5分钟的等待时间，所以实际上是23次
    let audioUploaded = AudioUploaded;
    while (retries <= maxRetries) {
      let progressInterval;
      if(audioUploaded === 'uploading' || retries > 0) {
        console.log('The audio file is still uploading. Please wait.');
        const videoData = await getVideoData(videoId, videoUrl);
        const { AudioUrl, AudioUploaded } = videoData;
        audioUploaded = AudioUploaded;
        if (AudioUrl && audioUploaded === 'uploaded') {
          console.log('The audio file has been uploaded. The audio URL is:', AudioUrl);
          setProgressOfUpload(100);
          return AudioUrl;
        } else if (!AudioUrl && audioUploaded === 'failed') {
          return null
        } else {
          // 添加轮询逻辑，等待一段时间后重新检查
          console.log('The audio file is still being processed. Waiting for 1 minute before checking again...');
          
          // 显示等待进度
          let waitProgress = setInterval(() => {
            setProgressOfUpload(prev => {
              if (prev >= 95) {
                return 95;
              }
              return prev + Math.random() * 1.5;
            });
          }, 300);
          
          // 等待1分钟后重新检查
          await new Promise(resolve => setTimeout(resolve, 60000));
          
          // 清除进度更新
          clearInterval(waitProgress);
          
          // 检查用户是否取消了操作
          if (userCancleTranscribeRef.current && expectedTotalRef.current === -1) {
            console.log('Operation cancelled by user during waiting period');
            return null;
          }
          retries++;
          // 重新调用自身进行检查
          // return getAudioUrlOfVideo(videoId, videoUrl, noteIDnum, uid, 'uploading');
        }
      } else if(audioUploaded !== 'uploading' && audioUploaded !== 'uploaded') {
        try {
          // 显示进度动画
          progressInterval = setInterval(() => {
            setProgressOfUpload(prev => {
              if (prev >= 95) {
                clearInterval(progressInterval);
                return 95;
              }
              return prev + Math.random() * 2; 
            });
          }, 200);
          
          // 直接使用传统的下载方式，而非任务系统
          console.log(`Requesting video and audio download: ${videoUrl}`);
          
          const response = await axios({
            method: 'post',
            url: '/api/getAudioUrlOfVideo',
            data: { 
              videoId,
              videoUrl, 
              noteIDnum, 
              uid
            },
            timeout: 300000 // 5分钟超时
          });
          
          clearInterval(progressInterval);
          
          if (response.data && response.data.audioUrl) {
            console.log('Successfully obtained the audio URL:', response.data.audioUrl);
            setProgressOfUpload(100);
            return response.data.audioUrl;
          } else {
            throw new Error('The server did not return a valid audio URL');
          }
        } catch (error) {
          clearInterval(progressInterval);
          const errorMessage = error.response?.data?.error || '处理视频时出错';
          const statusCode = error.response?.status;
          // 检查是否是连接关闭错误
          const isConnectionClosed = 
          error.message?.includes('connection closed') || 
          error.message?.includes('Download already in progress for this video') ||
          error.message?.includes('ERR_CONNECTION_CLOSED') ||
          error.code === 'ECONNRESET' ||
          error.code === 'ECONNABORTED' ||
          error.code === 'ETIMEDOUT' ||
          error.code === 'ERR_NETWORK' ||
          statusCode === 409 || 
          errorMessage.includes('Download already in progress for this video');
          
          // 如果是连接问题且未超过最大重试次数，切换到轮询模式
          if (isConnectionClosed && retries < maxRetries) {
            console.log(`Network connection error: ${error.message || error.code}. Switching to polling mode.`);
            audioUploaded = 'uploading';
            setProgressOfUpload(prev => Math.min(prev + 1, 95));
            
            // 添加延迟，避免立即重试导致服务器压力过大
            const retryDelay = Math.min(30000, 3000 * Math.pow(2, retries)); // 指数退避策略
            console.log(`Waiting ${retryDelay/1000} seconds before retry...`);
            await new Promise(resolve => setTimeout(resolve, retryDelay));
            
            retries++;
            console.log(`Retrying... (${retries}/${maxRetries})`);
          } else {
            console.log(`Attempt ${retries + 1}/${maxRetries + 1} failed:`, error.message);
            // 如果已达到最大重试次数，则退出重试
            if (retries === maxRetries) {
              console.error('Max retries reached');
            } 
            // console.error('Failed to obtain the audio URL:', error);
            if (error.response) {
              console.error('Error response data:', error.response.data);
              // console.error('Error status code:', error.response.status);
            }
            
            // 提供更具体的错误消息
            let errorMessage = 'Failed to download video and audio';
            if (error.response && error.response.data && error.response.data.error) {
              errorMessage = error.response.data.error;
            } else if (error.message) {
              errorMessage = error.message;
            }
            
            setError(errorMessage);
            setUploading(false);
            setProgressStatus('Failed');
            setVideoURLAddress({
              videoURL: '',
              videoID: '',
              audioURL: '',
              title: '',
              duration: 0,
              noteIDnum: '',
              lancode: ''
            });
            return null;
            // throw error;
          }
        }
      }
    }
    // 如果所有重试均失败，设置默认返回值
    console.error('Failed to obtain audioUrl of the video after all retries.');
    return null;
  };

  const gereatedUniqueNoteID = () => {
    let index = 0;
    if (userDataLocal?.History) {
      let numORItem = expectedTotalRef.current || 0 + cancelledBatchTasksRef.current.length || 0  - linkQueue.length || 0;
      if (numORItem < 0) {
        numORItem = 0;
      }
      index = userDataLocal?.History?.length +  numORItem;
    }

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
  
    const dateNumbers = `${year}${month}${day}`;
    const timeNumbers = `${hours}${minutes}${seconds}${milliseconds}`;
    const indexString = String(index).padStart(7, '0');

    return `${dateNumbers}${timeNumbers}${indexString}`;
  }

  const handleRenameUploadedAudioFile = async (audioFileName, newNameWithNoteID) => {
    if (!audioFileName) {
      console.error('Fiel not exist.');
      return;
    }

    const filename = audioFileName;
    const newFilename = newNameWithNoteID;
    const userid = user.uid;

    try {
      const response = await axios.put(`/api/upload/rename/${userid}/${filename}`, {
        newFilename
      });
      // console.log ('Delete uploaded audio file successfully!', response.data.message);
      // setUrl(null);
      // console.log(response.data.message);
      // console.log(response.data.newFilename); //newFilename+extension
      return response.data.url;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  //_______________________________________________________________________________________
  //_____________________batch transcribe__________________________________________________
  const startBatchTranscribe = async (audioURL, videoURL, videoID, duration, title, noteIDnum, lancode) => {
    if (userCancleTranscribeRef.current && expectedTotalRef.current === -1) {
      setProgressStatus('Cancelled');
      console.log('Transcription cancelled');
      return;
    }

    setError(null);
    setProgressStatus('Transcribing');
    setProgressOfTranscription(5);
    setIsTranscribing(true);

    try {
      const response = await axios.post('/api/startTranscription', { url: audioURL, noteIDnum: noteIDnum, uid: user.uid, language: lancode });
      const transcriptionId = response.data.transcriptionId;
      // console.log('transcriptionId:', transcriptionId);
      // console.log('response:', response);
      if (transcriptionId) {
        if (videoID && videoURL) {
          const newVideoData = { 
            Duration: duration, 
            Language: lancode || userDataLocal.Language.code, 
            PolishedText: '', 
            Title: title, 
            Transcript: '', 
            AudioUrl: audioURL, 
            TranscribeID: transcriptionId,
            VideoUrl: videoURL,
            AudioUploaded: 'uploaded'
          }
          updateVideoData(videoID, newVideoData);
        }
        currentTranscriptionTaskID = transcriptionId;
        createHistoryRecord(transcriptionId, audioURL, videoURL, videoID, duration, title, noteIDnum);
        checkTranscriptionStatus(transcriptionId, audioURL, videoURL, videoID, duration, title, noteIDnum); 
      } else {
        setError('Transcription ID is undefined.');
        setIsTranscribing(false);
      }
    } catch (error) {
      setError('Error starting transcription');
      setIsTranscribing(false);
    }
  }

  const checkTranscriptionStatus = async (id, audioURL, videoURL, videoID, duration, title, noteIDnum) => {
    // If this task is outdated, immediately exit with a history record.
    // if (currentTranscriptionTaskID !== id) {
    //   console.log("This transcription task is no longer active; aborting polling.");
    //   createHistoryRecord(id, audioURL, videoURL, videoID, duration, title, noteIDnum);
    //   return;
    // }

    let timeoutId;
    const useremail = userDataLocal?.Email;
    const currentTaskInfo = {id: id, url: audioURL, email: useremail, duration: duration, endTime: endTimeOfAudio, realtimeValue: false, videoURL: videoURL, videoID: videoID, title: title, noteIDnum: noteIDnum};
    const addORDelete = true;
    
    let retries = 0;
    
    // 计算视频时长（分钟）
    const durationMinutes = duration / 60;
    
    // 计算预期的最长等待时间（分钟）
    // 10分钟内的视频 => 至少10分钟等待时间
    // 10分钟以上的视频 => 最长等待时间 = 视频时长 * 1.5，但不超过4小时
    const targetWaitMinutes = durationMinutes <= 10 
      ? 10 
      : Math.min(durationMinutes * 1.5, 240); // 最长等待4小时(240分钟)
    
    // 计算基础延迟和最大延迟
    // 较短视频使用较短的基础延迟，长视频使用较长的基础延迟，以便更好地分配等待时间
    const baseDelay = durationMinutes < 30 ? 5000 : 10000; // 5秒或10秒基础延迟
    
    // 最大延迟上限根据视频时长调整，但不超过2分钟
    const maxDelay = Math.min(120000, durationMinutes * 2000); // 最长单次等待2分钟
    
    // 指数增长因子调整，使总等待时间更接近目标值
    // 较低的指数因子会产生更均匀分布的等待时间
    const exponentialFactor = 1.3;
    
    // 计算理论上达到目标等待时间所需的重试次数
    // 通过求和公式估算: sum(baseDelay*exponentialFactor^i) ≈ targetWaitMinutes*60000
    // 简化计算，使用近似值
    const estimatedRetries = Math.ceil(Math.log(targetWaitMinutes * 60000 / baseDelay) / Math.log(exponentialFactor));
    
    // 确保至少有10次重试机会
    const minRetries = 10;
    
    // 计算总重试次数，确保至少有最小重试次数
    const maxRetries = Math.max(minRetries, estimatedRetries * 2);
    
    console.log(`Video duration: ${durationMinutes.toFixed(2)} minutes, target wait time: ${targetWaitMinutes.toFixed(2)} minutes, maximum number of retries: ${maxRetries}`);

    updateTaskIDOfOfflinetranscribe(currentTaskInfo, addORDelete);
    while (retries <= maxRetries) {
      // Check if a new task has been started; if so, abort this loop.
      if (currentTranscriptionTaskID !== id) {
        // console.log("Task aborted due to new transcription initiation.");
        // createHistoryRecord(id, audioURL, videoURL, videoID, duration, title, noteIDnum);
        return;
      }

      // const controller = new AbortController();
      // timeoutId = setTimeout(() => {
      //   controller.abort();
      // }, 60000); // 60s timeout for this request

      try {
        const response = await axios.get('/api/checkTranscriptionStatus', { 
          params: { id, uid: user.uid, noteIDnum }, 
          timeout: 5000 
        });
        if (currentTranscriptionTaskID !== id) {
          // console.log("Task aborted during polling due to a new task starting.");
          // createHistoryRecord(id, audioURL, videoURL, videoID, duration, title, noteIDnum);
          return;
        }
        if (response.data.status === 'Succeeded') {
          // console.log('Succeeded! Transcription is:', response.data.transcriptionText);
          // console.log('Succeeded! response.data.resdata:', response.data.resdata);
          const transcript = response.data.transcriptionText;
          const subtitleWithTimestamp = response.data.subtitleWithTimestamp;
          const polishedText = '';
          if (videoID && videoURL) {
            const newVideoData = { Transcript: transcript, subtitleWithTimestamp: subtitleWithTimestamp}
            updateVideoData(videoID, newVideoData);
          }
          updateTranscription(transcript, id, audioURL, polishedText, videoURL, videoID, duration, title, noteIDnum, subtitleWithTimestamp);
          setProgressOfTranscription(100);
          setProgressStatus('Updating');
          setIsUpdatingHistory(true);
          if(id !== noteIDnum && id.includes('-')){
            handleDeleteTranscription(id);
          }
          // handleDeleteUploadedAudioFile();
          setTimeout(() => {
            setIsTranscribing(false);
          }, 100);
          setSumOFUploadedFiles(oldValue => oldValue + 1);
          return;
        } else if (response.data.status === 'Failed') {
          // if(response.data.properties.error.code === 'InvalidData' && response.data.properties.error.message === 'The audio format is invalid or cannot be detected.') {
          //   setError('The audio format is invalid or cannot be detected.');
          // }
          setProgressStatus('Failed');
          const errorText = 'Network error when processing transcription, please try again later.';
          setError(errorText);
          console.error('Transcription failed, response.data is:', response.data);
          setIsTranscribing(false);
          throw new Error(errorText);
        } else {
          setProgressOfTranscription(prev => Math.min(prev + 3, 95));
          // setProgressOfTranscription(prev => prev + Math.random() * 3);
          const retryDelay = Math.min(maxDelay, baseDelay * Math.pow(exponentialFactor, retries));
          
          // 计算当前已等待的总时间和预期总等待时间（以便显示进度）
          let totalWaitedSoFar = 0;
          for (let i = 0; i < retries; i++) {
            totalWaitedSoFar += Math.min(maxDelay, baseDelay * Math.pow(exponentialFactor, i));
          }
          const totalExpectedWait = targetWaitMinutes * 60 * 1000;
          const waitPercent = Math.min(100, (totalWaitedSoFar / totalExpectedWait) * 100).toFixed(1);

          console.log(`Retry delay: ${(retryDelay/1000).toFixed(1)} seconds (${retries+1}/${maxRetries}), Waited: ${(totalWaitedSoFar/60000).toFixed(1)} minutes, Completed: ${waitPercent}%`);

          await new Promise(resolve => setTimeout(resolve, retryDelay));
          
          retries++;
        }
      } catch (error) {
        if (currentTranscriptionTaskID !== id) {
          // console.log("Task aborted during error catch due to new task initiation.");
          // createHistoryRecord(id, audioURL, videoURL, videoID, duration, title, noteIDnum);
          return;
        }
        // 如果捕获到的错误是超时错误，则认为转写还在处理中，继续轮询
        let transcribeTaskStillWorking = false;
        if (error.response && error.response.status === 404) {
          if(error.response.data.includes === 'Transcribe task still working, please wait') {
            transcribeTaskStillWorking = true;
          }
        } 
        if (error.message?.includes('connection closed') || 
            error.message?.includes('ERR_CONNECTION_CLOSED') || 
            error.code === 'ECONNRESET' || 
            error.code === 'ECONNABORTED' || 
            error.code === 'ETIMEDOUT' || 
            error.code === 'ERR_NETWORK' || transcribeTaskStillWorking) {
          setProgressOfTranscription(prev => Math.min(prev + 1, 95));
          // 使用优化的指数退避策略
          const retryDelay = Math.min(maxDelay, baseDelay * Math.pow(exponentialFactor, retries));
          
          // 计算当前已等待的总时间和预期总等待时间（以便显示进度）
          let totalWaitedSoFar = 0;
          for (let i = 0; i < retries; i++) {
            totalWaitedSoFar += Math.min(maxDelay, baseDelay * Math.pow(exponentialFactor, i));
          }
          const totalExpectedWait = targetWaitMinutes * 60 * 1000;
          const waitPercent = Math.min(100, (totalWaitedSoFar / totalExpectedWait) * 100).toFixed(1);
          
          console.log(`Retry delay: ${(retryDelay/1000).toFixed(1)} seconds (${retries+1}/${maxRetries}), Waited: ${(totalWaitedSoFar/60000).toFixed(1)} minutes, Completed: ${waitPercent}%`);

          await new Promise(resolve => setTimeout(resolve, retryDelay));
          
          retries++;

        } else {
          console.error('Error checking transcription status:', error);
          // setError('Network error when processing transcription, please try again later.');
          if (timeoutId) clearTimeout(timeoutId);
          createHistoryRecord(id, audioURL, videoURL, videoID, duration, title, noteIDnum);
          setProgressOfTranscription(100);
          setProgressStatus('Updating');
          setIsUpdatingHistory(true);
          // handleDeleteTranscription(id);
          // handleDeleteUploadedAudioFile();
          setTimeout(() => {
            setIsTranscribing(false);
          }, 100);
          setSumOFUploadedFiles(oldValue => oldValue + 1);
          return;
          // throw error;
        }
      }
    } 

    // 4. 检查是否达到最大重试次数
    if (retries >= maxRetries) {
      console.log(`The maximum number of retries (${maxRetries}) has been reached, and the process is forced to complete`);
      // 达到最大重试次数时，可以选择强制完成或继续重试
      // 这里是强制完成的代码
      createHistoryRecord(id, audioURL, videoURL, videoID, duration, title, noteIDnum);
      setProgressOfTranscription(100);
      setProgressStatus('Updating');
      setIsUpdatingHistory(true);
      setTimeout(() => {
        setIsTranscribing(false);
      }, 100);
      setSumOFUploadedFiles(oldValue => oldValue + 1);
    }
  };

  function createHistoryRecord(id, audioURL, videoURL, videoID, duration, title, noteIDnum) {
    const transcript = 'Transcript updating...';
    // Update transcription record as history without waiting further
    updateTranscription(transcript, id, audioURL, '', videoURL, videoID, duration, title, noteIDnum, '');
  }

  const updateTaskIDOfOfflinetranscribe = async (taskInfo, addORDelete) => {
    //addORDelete: true is add, false is delete
    const id = taskInfo.id;
    setTaskIDOfOfflinetranscribe((prevBuffer) => {
      const taskExists = prevBuffer.some((item) => item.id === id);
  
      if (taskExists) {
        // 如果存在该元素
        if(addORDelete){
          //如果已存在该元素，且是添加操作，则什么都不做
          return prevBuffer;
        } else {
          //如果已存在该元素，且是删除操作，则删除该元素
          return prevBuffer.filter((item) => item.id !== id);
        }
      } else {
        // 如果不存在该元素
        if(addORDelete){
          //如果不存在该元素，且是添加操作，则添加该元素
          return [...prevBuffer, taskInfo];
        } else {
          //如果不存在该元素，且是删除操作，则什么都不做
          console.log('The task is not exist in the taskIDOfOfflinetranscribe buffer, so it can not be deleted.');
          return prevBuffer;
        }
      }
    });
  };

  const handleDeleteTranscription = async (id) => {
    try {
      const response = await axios.delete(`/api/deleteTranscription/${id}`);
      // console.log ('Delete Transcription tast from  microsoft successfully!',response.data.message);
      setError(null);

      const useremail = userDataLocal?.Email;
      const currentTaskInfo = {id: id, email: useremail};
      const addORDelete = false;
      updateTaskIDOfOfflinetranscribe(currentTaskInfo, addORDelete);
    } catch (err) {
      setError('Error deleting transcription');
      console.error(err);
    }
  };
  //_______________________________________________________________________________________
  //handle cancel button
  const handleCancel = () => {
    if (audioFileUserUpload || progressStatus === 'Validating' || progressStatus === 'Uploading' || progressStatus === 'Converting') {
      setUserCancleTranscribe(true);
      resetAllValues();
      setNoteExist(null);
    }
  }

  const resetAllValues = (batchORNOT) => {
    setIsPreCheckingAudioFile(false);
    setIsUpdatingHistory(false);
    setAudioFileUserUploadArray([]);
    setVideoURLAddressTemp(null);
    setAudioFileUserUpload(null);
    setFileName('');
    setDuration(0);
    setProgressOfUpload(0);
    updateTranscription('', '', '', '', '', '', 0, '', '', '');
    setUploadedFileName('');
    setError(null);
    setUploading(false);
    setIsTranscribing(false);
    setProgressStatus('');
    setBatchTaskLength(0);
    currentTranscriptionTaskID = null; // 退出当前正在轮询的 checkTranscriptionStatus 任务
    if (batchORNOT) {
      transcriptsForBatch.current = [];
      queueBusyRef.current = false;
      setLinkQueue([]);
      expectedTotalRef.current = 0; // 关键修复：重置期望的总任务数
      if (cancelledBatchTasksRef.current.length > 0) {
        // 显示每个被取消任务的 URL 和原因
        const details = cancelledBatchTasksRef.current
          .map(task => `${task.url} (Error: ${task.error})`)
          .join('; ');
        setMessageShowToUser(
          `${cancelledBatchTasksRef.current.length} tasks have been cancelled: ${details}. Other tasks are being processed normally, so you can close this popup. Drag and drop an audio file here. Supported audio formats: mp3, wav, ogg, flac, wma, aac, amr, webm, mp4, m4a, speex.`
        );
        cancelledBatchTasksRef.current = [];
      } else {
        setMessageShowToUser('Batch procesing, you can close this popup. Drag and drop an audio file here. Supported audio formats: mp3, wav, ogg, flac, wma, aac, amr, webm, mp4, m4a, speex.');
      }
    }else {
      setMessageShowToUser('Drag and drop an audio file here. Supported audio formats: mp3, wav, ogg, flac, wma, aac, amr, webm, mp4, m4a, speex.');
    }
  }

  //2024.06.02 
  const gotoHistory = () => {
    setError(null);
    handleClose();
    if (noteExist) {
      goHistory(noteExist); 
    } else {
      goHistory();
    }
    setNoteExist(null);
  }

  //_________________________________________________________

  return (
    <div className={`popup-background-FAQs ${isVisibleSTT ? 'active' : (completedAllOfFiles ? '' : 'minimized')}`}>
      <div className='popup-FAQs'>
        <div className='header-FAQs'>
          <h1 className='h1-FAQs'>Speech To Text</h1>
          <span className="close-FAQs" onClick={handleClose}>&times;</span>
        </div>

        {/* {isPreCheckingAudioFile &&
          <div className="fileStatus-STT">
                  <span 
                    className="file-name" 
                    title={fileName}
                  >
                    {fileName}
                  </span>
                  <span >{(duration/60).toFixed(2)} mins</span>
                  {/* <div style={{ width: '25%'}}>
                    <div style={{ height: '5px', backgroundColor: '#e0e0e0', borderRadius: '3px', overflow: 'hidden' }}>
                      <div style={{ width: `${isPreCheckingAudioFile ? progressOfUpload : progressOfTranscription}%`, backgroundColor: '#e7994b', height: '100%' }} />
                    </div>
                  </div> 
                  <span style={{ textAlign: 'right' }}>{progressStatus}</span>
                </div>} */}


        {(isPreCheckingAudioFile || uploading || isTranscribing || messageShowToUser.includes('please wait') || (fileName !== '' && transcription.text !== '')) &&
          <div className="fileStatus-STT">
                  <span 
                    className="file-name" 
                    title={fileName}
                  >
                    {fileName}
                  </span>
                  <span >{(duration/60).toFixed(2)} mins</span>
                  <div style={{ width: '25%'}}>
                    <div style={{ height: '5px', backgroundColor: '#e0e0e0', borderRadius: '3px', overflow: 'hidden' }}>
                      <div style={{ width: `${isPreCheckingAudioFile ? progressOfPrecheck : (uploading ? progressOfUpload : progressOfTranscription)}%`, backgroundColor: '#e7994b', height: '100%' }} />
                    </div>
                  </div>
                  <span style={{ textAlign: 'right' }}>{progressStatus}</span>
                </div>}

        <div className="content-STT-body" style={{height: completedAllOfFiles ? '76%' : '71%'}}>
          <div className="dropzone-STT" onDrop={handleDrop}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', flex: 1 }}>
            { !error && <p style={{ padding: '0 20px' }}>{messageShowToUser}{(uploading || isTranscribing || isUpdatingHistory || isPreCheckingAudioFile || linkQueue.length > 0) && <span className="dots"> </span>}</p>}
              {/* {!error && transcription==='' &&  <p>{fileName ? fileName : 'Drag and drop an audio file here'}</p>} */}
            {/* {error && transcription==='' && <p style={{animation: 'blink 1s infinite'}}>{error}</p>} */}
            {error && <p style={{animation: 'blink 1s infinite', padding: '0 20px'}}>{error}</p>}
              {/* {!error && transcription!=='' && audioFileUserUploadArray.length === 0 && <p>All of the files have been done. Drag and drop audio files here agin.</p>} */}
            
            </div>
            <input style={{display: 'none'}} type="file" multiple accept="audio/*" id="fileInput" onChange={handleFileChange} />

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', flex: '1 1 0%', alignItems: 'flex-end', width: '80%', paddingBottom: '10px' }}>
              <input   //textarea
                type="text"
                value={videoURLAddressTemp}
                onChange={handleUrlChange}
                placeholder="Enter multiple video URLs, separated by commas."
                className='input-STT'
              />
              <button
                style={{ marginLeft: '5px', width: '50px', height: '30px' }}
                onClick={handleUrlArrayPreProcess}
                className={(uploading || isPreCheckingAudioFile) ? "appstyle-btngray-disable" : "appstyle-btn"}
                disabled={uploading || isPreCheckingAudioFile}
              >
                GO
              </button>
             </div>
          </div>

          
          {/* <progress value={uploading ? progressOfUpload : progressOfTranscription} max="100" class="progress-bar"></progress> */}
          {/* {transcription && <p>Transcription: {transcription}</p>} */}
        </div>

        {!completedAllOfFiles && <div className="note-STT"><p>Note: You can close this pop-up anytime, the task continues in the background.</p></div>}
         
        <div className="footer-STT">
          {!uploading && <button onClick={() => document.getElementById('fileInput').click()} 
            className={uploading ? "appstyle-btngray-disable" : "appstyle-btn"}
            disabled={uploading}>Browse files</button>}
          {/* {!uploading && <button onClick={testVideoLinkPaste} 
            className={uploading ? "appstyle-btngray-disable" : "appstyle-btn"}
            disabled={uploading}>Test Video Link</button>} */}
          {(uploading || progressStatus === 'Validating' || progressStatus === 'Uploading' || progressStatus === 'Converting') && <button onClick={handleCancel} 
            className="appstyle-btn">Cancel</button>}
          {((!uploading && !isTranscribing && transcription.text !== '' && updatedSuccessfully) || noteExist) && <button onClick={gotoHistory} 
            className="appstyle-btn">Transcript</button>}
        </div>
        
      </div>
    </div>
  );
};

export default SpeechToTextOffline;

const getAudioDuration = (file) => {
  return new Promise((resolve) => {
      const audio = document.createElement('audio');
      audio.src = URL.createObjectURL(file);
      audio.addEventListener('loadedmetadata', () => {
          resolve(audio.duration);
      });
  });
};

const getAudioChannels = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = function(ev) {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      audioContext.decodeAudioData(ev.target.result, function(buffer) {
        resolve(buffer.numberOfChannels);
      });
    };
    reader.readAsArrayBuffer(file);
  });
};

